import { httpService } from '@/services/httpService'
import { log } from '@/utils/DebugLogger'
import { config } from '@/services/configService'

export interface Language {
  ID: number
  Name: string
}

interface LanguagesListResponse {
  success: boolean
  dados?: Array<{ id: number; name: string }>
  data?: Array<{ id: number; name: string }>
  error?: string
}

export function useLanguages() {
  const fetchLanguages = async (): Promise<Language[]> => {
    log('useLanguages', 'fetchLanguages', 'Fetching languages')
    try {
      // External Go translations-service — no PHP contract applies
      const response = await httpService.get<LanguagesListResponse>((config as any).api.idiomasHost + '/languages/list')
      log('useLanguages', 'fetchLanguages', 'Raw response', response)

      const languagesData = response.dados || response.data || []

      const languages: Language[] = languagesData.map((lang) => ({
        ID: lang.id,
        Name: lang.name
      }))

      log('useLanguages', 'fetchLanguages', 'Languages loaded', languages)
      return languages
    } catch (error) {
      log('useLanguages', 'fetchLanguages', 'Error loading languages', error)
      throw error
    }
  }

  return {
    fetchLanguages
  }
}
